export default "__VITE_PUBLIC_ASSET__15d85108__"